// extracted by mini-css-extract-plugin
module.exports = {"content":"CriteriaFilterCard_content__2kaVj","card":"CriteriaFilterCard_card__1JGcv","active":"CriteriaFilterCard_active__3SRBM"};